import { AppoinitmentType } from "../types/AppoinitmentType";
let initialState = {
  appointmentList: [],
  appointmentInfo: {},
  isAppointmentUpdated: false,
  errorDescription:''
};
export function appointment(state = initialState, action) {
  switch (action.type) {
    case AppoinitmentType.UPDATE_APPOINTMENT_SUCCESS: {
      state.isAppointmentUpdated = true;
      return state;
    }
    case AppoinitmentType.GET_ALL_APPOINTMENT_SUCCESS: {
      state.appointmentList = action.data;
      state.isAppointmentUpdated=false;
      state.appointmentInfo={};
      return state;
    }
    case AppoinitmentType.GET_APPOINTMENT_BY_ID_SUCCESS: {
      state.errorDescription='';
      state.appointmentList = [];
      state.appointmentInfo = action.data;
      return state;
    }
    case AppoinitmentType.CLEAR_ALL_STATE: {
      state.appointmentList = [];
      state.isAppointmentUpdated=false;
      state.appointmentInfo={};
      state.errorDescription='';
      return state;
    }
    case AppoinitmentType.ERROR_IN_APPOINTMENT_REQUEST:{
      state.errorDescription = action.data;
      return state;
    }
    case AppoinitmentType.UPDATE_APPOINTMENT_REQUEST:{
      state.errorDescription = '';
      return state;
    }
    default:
      return state;
  }
}
